module.exports = __webpack_public_path__ + "static/media/complexity.cf222111.png";